'use strict';

import BaseService from './base.service';

class OCommentsService extends BaseService {
  static $inject = ['OperationComment', 'SegaUser'];
  constructor(OperationComment, SegaUser) {
    super(OperationComment, SegaUser);
    Object.assign(this, {
      OperationComment
    });
  }
}

export default OCommentsService;
